import React, { useState, useEffect } from 'react';
import TopicCard from './TopicCard';
import { Container, Row, Col, Badge, Button, Card, CardHeader, CardBody } from "shards-react";

const axios = require('axios').default;

export default function TopicsOverview() {
  const [data, setData] = useState([]);
  const visibleCharts = 200;

  function compareTopicId(a, b) {
    if (a.topic_number > b.topic_number) return -1;
    if (b.topic_number > a.topic_number) return 1;

    return 0;
  }

  useEffect(() => {
    axios.get('topicsData.json') // topicsData.json
      .then(response => {
        response.data.sort(compareTopicId);

        setData(response.data);

      })
  }, []);

  return (
    <Container style={{ maxWidth: '100%' }}>
      

      {data && data.slice(0, visibleCharts).map((topicData) =>
        <Row key={topicData.title}>
          <Col className="py-4"><TopicCard data={topicData} /></Col>
          {/* <div>
      </div> */}
          
        </Row>
        
        
        

      )}

      <Row key="table" className="mx-2 my-4">
        <Col>
          <Card className="overflow-hidden">
            <CardHeader className="p-3 bg-dark">
              <h6 className="m-0 text-white">All tracked topics</h6>
            </CardHeader>
            <CardBody className="bg-light p-0 pb-3 table-responsive" >
              <table className="table mb-0">
                <thead className="bg-light">
                <tr>
                  <th scope="col">#</th>
                    <th scope="col" className="border-0">
                    Topic
                  </th>

                  <th scope="col" className="border-0">
                      High Botness Count <sup>1</sup>
                      
                  </th>
                  <th scope="col" className="border-0">
                    Fully Automated Accounts <sup>2</sup>
                  </th>
                  
                    <th scope="col" className="border-0">
                     Total Accounts Collected
                  </th>
                    
                    <th scope="col" className="border-0">
                      External URL
                  </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.map((topicData) =>
                    <tr key={"tr" + topicData.title} className="p-4">
                      
                      <th scope="row">{topicData.topic_number}</th>
                      <td>{topicData.title}</td>
                      <td><Badge theme="danger">{topicData.high_botness_cnt}</Badge>
                      </td>
                      <td><Badge theme="danger">{topicData.automated}</Badge>
                      </td>
                      <td><Badge theme="info">{topicData.total_count}</Badge>
                      </td>


                      
                      <td><a href={topicData.url}><Button outline theme="info" className="float-right">
                      Fact Analysis </Button></a></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>



  )
}





